// Aqui se establecen las definiciones la fuente que usan
const fonts = {
  GothamBook: 'GothamBook',
  GothamMedium: 'GothamMedium',
  GothamBold: 'GothamBold',
};

export default fonts;
